/**
 * A giant object that has smaller objects as properties.
 * Each Smaller object has a name {string} propert and
 * a rules array. Even if there is one rule statement, wrap
 * it in an array. 
 */
export const helpObject = {
    travel: {
        name:"Travel",
        rules:[`A travel premium is only eligible for payment when a physician is required to travel from one location to another location
        but is not eligible for payment when the travel occurs within the same long-term care home, hospital complex or within buildings situated
        on same hospital campus.`],
    },
    firstPersonSeen: {
        name:'First Person Seen',
        rules:[`When making a special visit, the first person seen is the earliest patient visited at a location. 
        If this is an additional patient seen at a particular location, leave this unchecked. If you went to multiple seperate locations in the same day and this is the first patient seen at one of those locations, check this box.`]
    },
    specialVisit: {
        name:"Special Visit",
        rules:[`If there was a requirment to make a visit to a location outside your regular clinic, additional billing codes called special visit premiums may apply.\n
        There are several locations which have different codes, so make sure to specifiy the correct location type in the drop down.`]
    },
    sacrificeOfHours: {
        name: 'Sacrifice of Office Hours',
        rules:[`Sacrifice of office hours means that an insured service was rendered due to the demands of the patient/patient's condition
        making it so that the physician made an unscheduled non elective visit to the patient at a time the physican had an office visit booked with one or more patients. 
        If due to this unscheduled non-elective visit, an office visit was delayed or canceled, check this box..`],
    },


}
